import { useState } from 'react';

export function useServicePagination<T>(items: T[], filterKey: string) {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [previousFilter, setPreviousFilter] = useState(filterKey);
  const lastPage = Math.max(0, Math.ceil(items.length / pageSize) - 1);
  const page = filterKey !== previousFilter ? 0 : Math.min(pageIndex, lastPage);
  if (filterKey !== previousFilter) {
    setPreviousFilter(filterKey);
    setPageIndex(0);
  } else if (pageIndex !== page) {
    setPageIndex(page);
  }
  return {
    rows: items.slice(page * pageSize, (page + 1) * pageSize),
    pagination: {
      pageIndex: page,
      pageSize,
      total: items.length,
      onPageChange: setPageIndex,
      onPageSizeChange: (size: number) => {
        setPageSize(size);
        setPageIndex(0);
      },
      label: 'services',
    },
  };
}
